import { client } from '../../common/client/apollo-client';
import { loader } from 'graphql.macro';
import { trackCustomHeapEvent } from '../../../utils/heap';
import { ErrorMessages } from '../../../utils/errorMessages';
import { IPaymentInfo } from '../../payments/models/payment-info-interface';

const getPaymentInfoQuery: any = loader('../../../graphql/queries/get-payment-info.graphql');

class PaymentInformationService {
  async getPaymentInformation(claimNumber:string): Promise<IPaymentInfo []> {
    try {
      const response = await client(true).query({
        query: getPaymentInfoQuery,
        variables: {
          claimNumber: claimNumber.split('-')[0],
          exposureNumber: claimNumber.split('-')[1]
        },
        fetchPolicy: 'network-only'
      });

      if (response?.errors?.[0]?.message) {
        throw new Error(response?.errors?.[0]?.message);
      }

      if (!response?.data?.getPaymentInfo) {
        throw new Error(ErrorMessages.CLAIM_NOT_FOUND);
      }
      trackCustomHeapEvent('get-payment-information-success', {});
      return response?.data?.getPaymentInfo?.results || [];

    } catch (error) {
      trackCustomHeapEvent('get-payment-information-error', {});
      throw new Error(ErrorMessages.SERVICE_UNAVAILABLE);
    }
  }
}

export default PaymentInformationService;

